<div [class]="'info-banner flex align-center justify-space-between wrap radius-3 brd brd-1 p-3 mt-3 mx-3 ' + borderClass + ' ' + bgClass">
  <div class="mb-md-2">
    <span [class]="'text-white small weight-medium py-1 px-2 radius-1 mr-3 ' + badgeClass">{{ labelKey | translate }}</span>
    <span [class]="'h6 m-0 ' + textClass">{{ messageKey | translate }}</span>
  </div>

  <button mat-flat-button *ngIf="showButton" [class]="'text-white small weight-medium py-2 px-6 brd brd-1 radius-1 ' + buttonClass" (click)="onClick()">
    {{ buttonKey | translate }}
  </button>
</div>
